"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var react_router_dom_1 = require("react-router-dom");
var xlsx_1 = require("xlsx");
var recoil_1 = require("recoil");
var dayjs_1 = __importDefault(require("dayjs"));
var api = __importStar(require("@/api"));
var components_1 = require("@/components");
var utils_1 = require("@/utils");
var constants_1 = require("@/constants");
var store_1 = require("@/store");
var hooks_1 = require("@/hooks");
var Button_component_1 = require("@/components/common/Button/Button.component");
var ApplicationStatusBadge_component_1 = __importStar(require("@/components/common/ApplicationStatusBadge/ApplicationStatusBadge.component"));
var Styled = __importStar(require("./ApplicationList.styled"));
var APPLICATION_EXTRA_SIZE = 100;
var DEFAULT_OPTION = { label: '전체', value: '' };
var ApplicationList = function () {
    var _a, _b;
    var handleEmailModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.emailSendModalDialog));
    var handleResultModal = (0, recoil_1.useSetRecoilState)((0, store_1.$modalByStorage)(store_1.ModalKey.changeResultModalDialog));
    var _c = (0, react_router_dom_1.useLocation)(), pathname = _c.pathname, search = _c.search;
    var _d = __read((0, react_router_dom_1.useSearchParams)(), 2), searchParams = _d[0], setSearchParams = _d[1];
    var teamName = searchParams.get('team');
    var teamId = (0, recoil_1.useRecoilValue)((0, store_1.$teamIdByName)(teamName));
    var myTeamName = (0, recoil_1.useRecoilValue)(store_1.$profile)[0];
    var generationNumber = (0, recoil_1.useRecoilValue)(store_1.$generationNumber);
    var isMyTeam = (0, react_2.useMemo)(function () {
        return !teamName ||
            teamName.toLowerCase() === myTeamName.toLowerCase() ||
            myTeamName === 'BRANDING' ||
            myTeamName === 'MASHUP';
    }, [myTeamName, teamName]);
    var page = searchParams.get('page') || '1';
    var size = searchParams.get('size') || '20';
    var confirmStatus = searchParams.get('confirmStatus') || '';
    var resultStatus = searchParams.get('resultStatus') || '';
    var searchWord = searchParams.get('searchWord') || '';
    var _e = __read((0, react_2.useState)([
        { accessor: 'applicant.name', type: constants_1.SORT_TYPE.DEFAULT },
        { accessor: 'submittedAt', type: constants_1.SORT_TYPE.DEFAULT },
        { accessor: 'result.interviewStartedAt', type: constants_1.SORT_TYPE.DEFAULT },
    ]), 2), sortTypes = _e[0], setSortTypes = _e[1];
    var sortParam = (0, react_2.useMemo)(function () {
        var matched = sortTypes.find(function (sortType) { return sortType.type !== constants_1.SORT_TYPE.DEFAULT; });
        if (!matched)
            return '';
        var accessor = matched.accessor, type = matched.type;
        var accessorKeys = accessor.split('.');
        if (accessorKeys[0] === 'result') {
            var resultAccessor = ['applicationResult'].concat(accessorKeys.slice(1)).join('.');
            return "".concat(resultAccessor, ",").concat(type);
        }
        return "".concat(accessor, ",").concat(type);
    }, [sortTypes]);
    var applicationParams = (0, react_2.useMemo)(function () { return ({
        page: parseInt(page, 10) - 1,
        size: parseInt(size, 10),
        teamId: parseInt(teamId, 10) || undefined,
        searchWord: searchWord,
        confirmStatus: confirmStatus,
        resultStatus: resultStatus,
        sort: sortParam,
        generationNumber: generationNumber,
    }); }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [page, size, teamId, searchWord, sortParam, confirmStatus, resultStatus, generationNumber]);
    var _f = __read((0, react_2.useState)(0), 2), totalCount = _f[0], setTotalCount = _f[1];
    var _g = __read((0, recoil_1.useRecoilStateLoadable)((0, store_1.$applications)(applicationParams)), 1), _h = _g[0], state = _h.state, tableRows = _h.contents;
    var refreshApplications = (0, recoil_1.useRecoilRefresher_UNSTABLE)((0, store_1.$applications)(applicationParams));
    var _j = __read((0, react_2.useState)([]), 2), selectedRows = _j[0], setSelectedRows = _j[1];
    var selectedResults = (0, react_2.useMemo)(function () {
        return (0, utils_1.uniqArray)(selectedRows.map(function (row) { return row.result.status; }));
    }, [selectedRows]);
    var isLoading = state === 'loading';
    var _k = __read((0, react_2.useState)(tableRows.data || []), 2), loadedTableRows = _k[0], setLoadedTableRows = _k[1];
    var getWorkBook = (0, hooks_1.useConvertToXlsx)({
        workSheet: selectedRows.map(function (each) { return ({
            이름: each.applicant.name,
            전화번호: each.applicant.phoneNumber,
            지원플랫폼: each.team.name,
            지원일시: each.submittedAt
                ? (0, utils_1.formatDate)(each.submittedAt, 'YYYY년 M월 D일(ddd) a hh시 mm분')
                : '',
            면접일시: each.result.interviewStartedAt
                ? (0, utils_1.formatDate)(each.result.interviewStartedAt, 'YYYY년 M월 D일(ddd) a hh시 mm분')
                : '',
            사용자확인여부: ApplicationStatusBadge_component_1.ApplicationConfirmationStatus[each.confirmationStatus],
            합격여부: ApplicationStatusBadge_component_1.ApplicationResultStatus[each.result.status],
        }); }),
        teamName: teamName || '전체',
        isLoading: isLoading,
    }).getWorkBook;
    var _l = (0, hooks_1.usePagination)({
        totalCount: (_a = tableRows.page) === null || _a === void 0 ? void 0 : _a.totalCount,
    }), pageOptions = _l.pageOptions, handleChangePage = _l.handleChangePage, handleChangeSize = _l.handleChangeSize;
    var _m = (0, hooks_1.useDirty)(1), makeDirty = _m.makeDirty, isDirty = _m.isDirty;
    var handleSelectAll = (0, react_2.useCallback)(function (checkedValue) { return __awaiter(void 0, void 0, void 0, function () {
        var applications;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!checkedValue) return [3 /*break*/, 1];
                    setSelectedRows([]);
                    return [3 /*break*/, 3];
                case 1: return [4 /*yield*/, api.getApplications({
                        page: 0,
                        size: tableRows.page.totalCount + APPLICATION_EXTRA_SIZE,
                        teamId: parseInt(teamId, 10) || undefined,
                        generationNumber: generationNumber,
                    })];
                case 2:
                    applications = _a.sent();
                    setSelectedRows(applications.data);
                    if (applications.page) {
                        setTotalCount(applications.page.totalCount);
                    }
                    _a.label = 3;
                case 3: return [2 /*return*/];
            }
        });
    }); }, [(_b = tableRows.page) === null || _b === void 0 ? void 0 : _b.totalCount, teamId, generationNumber]);
    var columns = [
        {
            title: '이름',
            accessor: 'applicant.name',
            idAccessor: 'applicationId',
            widthRatio: '12%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue, id = _a.id, handleClickLink = _a.handleClickLink, applicationParamStates = _a.applicationParams;
                return ((0, jsx_runtime_1.jsxs)(Styled.FormTitleWrapper, __assign({ title: cellValue }, { children: [(0, jsx_runtime_1.jsx)(Styled.FormTitle, { children: cellValue }, void 0), handleClickLink ? ((0, jsx_runtime_1.jsx)(Styled.TitleButton, { type: "button", onClick: handleClickLink }, void 0)) : ((0, jsx_runtime_1.jsx)(Styled.TitleLink, { to: "".concat(constants_1.PATH.APPLICATION, "/").concat(id), state: __assign(__assign({}, applicationParamStates), { from: "".concat(pathname).concat(search) }) }, void 0))] }), void 0));
            },
        },
        {
            title: '전화번호',
            accessor: 'applicant.phoneNumber',
            widthRatio: '13%',
        },
        {
            title: '지원플랫폼',
            accessor: 'team.name',
            widthRatio: '9%',
        },
        {
            title: '지원일시',
            accessor: 'submittedAt',
            widthRatio: '20%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return cellValue ? (0, utils_1.formatDate)(cellValue, 'YYYY년 M월 D일 A h시 m분') : '-';
            },
        },
        {
            title: '면접일시',
            accessor: 'result.interviewStartedAt',
            widthRatio: '20%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return cellValue ? (0, utils_1.formatDate)(cellValue, 'YYYY년 M월 D일 A h시 m분') : '-';
            },
        },
        {
            title: '사용자확인여부',
            accessor: 'confirmationStatus',
            widthRatio: '13%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return ((0, jsx_runtime_1.jsx)(Styled.Center, { children: (0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationConfirmationStatus[cellValue] }, void 0) }, void 0));
            },
        },
        {
            title: '합격여부',
            accessor: 'result.status',
            widthRatio: '13%',
            renderCustomCell: function (_a) {
                var cellValue = _a.cellValue;
                return ((0, jsx_runtime_1.jsx)(Styled.Center, { children: (0, jsx_runtime_1.jsx)(ApplicationStatusBadge_component_1.default, { text: ApplicationStatusBadge_component_1.ApplicationResultStatus[cellValue] }, void 0) }, void 0));
            },
        },
    ];
    var applicationConfirmStatusOptions = (0, react_2.useMemo)(function () { return __spreadArray([
        DEFAULT_OPTION
    ], __read(Object.keys(ApplicationStatusBadge_component_1.ApplicationConfirmationStatus).reduce(function (acc, cur) { return __spreadArray(__spreadArray([], __read(acc), false), [
        {
            label: ApplicationStatusBadge_component_1.ApplicationConfirmationStatus[cur],
            value: cur,
        },
    ], false); }, [])), false); }, []);
    var applicationResultStatusOptions = (0, react_2.useMemo)(function () { return __spreadArray([
        DEFAULT_OPTION
    ], __read(Object.keys(ApplicationStatusBadge_component_1.ApplicationResultStatus).reduce(function (acc, cur) { return __spreadArray(__spreadArray([], __read(acc), false), [
        {
            label: ApplicationStatusBadge_component_1.ApplicationResultStatus[cur],
            value: cur,
        },
    ], false); }, [])), false); }, []);
    var searchOptionBarFilters = [
        {
            title: '합격여부',
            options: applicationResultStatusOptions,
            key: 'resultStatus',
            defaultOption: DEFAULT_OPTION,
        },
        {
            title: '사용자 확인여부',
            options: applicationConfirmStatusOptions,
            key: 'confirmStatus',
            defaultOption: DEFAULT_OPTION,
        },
    ];
    (0, react_2.useEffect)(function () {
        if (!isLoading) {
            setLoadedTableRows(tableRows.data);
            setTotalCount(tableRows.page.totalCount);
            makeDirty();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading, tableRows]);
    (0, react_2.useEffect)(function () {
        searchParams.delete('searchKeyword');
        setSearchParams(searchParams);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [teamName]);
    (0, react_2.useLayoutEffect)(function () {
        if (isDirty && !isLoading) {
            window.scrollTo({ top: 179, left: 0, behavior: 'smooth' });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadedTableRows]);
    (0, hooks_1.useUnmount)(function () {
        refreshApplications();
    });
    return ((0, jsx_runtime_1.jsxs)(Styled.PageWrapper, { children: [(0, jsx_runtime_1.jsx)(Styled.Heading, { children: "\uC9C0\uC6D0\uC11C \uB0B4\uC5ED" }, void 0), (0, jsx_runtime_1.jsxs)(Styled.StickyContainer, { children: [(0, jsx_runtime_1.jsx)(components_1.TeamNavigationTabs, {}, void 0), (0, jsx_runtime_1.jsx)(components_1.SearchOptionBar, { placeholder: "\uC774\uB984, \uC804\uD654\uBC88\uD638 \uAC80\uC0C9", filters: searchOptionBarFilters }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.Table, { prefix: "application", topStickyHeight: 14.1, columns: columns, rows: loadedTableRows, isLoading: isLoading, supportBar: {
                    totalCount: totalCount,
                    totalSummaryText: '총 지원인원',
                    selectedSummaryText: '명 선택',
                    buttons: [
                        (0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.xs, shape: Button_component_1.ButtonShape.defaultLine, onClick: function () {
                                return handleEmailModal({
                                    key: store_1.ModalKey.emailSendModalDialog,
                                    props: {
                                        selectedApplications: selectedRows,
                                        showSummary: true,
                                    },
                                    isOpen: true,
                                });
                            }, disabled: selectedResults.length === 0 && isMyTeam }, { children: "\uC774\uBA54\uC77C \uBC1C\uC1A1" }), void 0),
                        (0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.xs, shape: Button_component_1.ButtonShape.defaultLine, onClick: function () {
                                return handleResultModal({
                                    key: store_1.ModalKey.changeResultModalDialog,
                                    props: {
                                        selectedList: selectedRows.map(function (row) { return row.applicationId; }),
                                        selectedResults: selectedResults,
                                        refreshList: function () {
                                            refreshApplications();
                                            setSelectedRows([]);
                                        },
                                    },
                                    isOpen: true,
                                });
                            }, disabled: selectedResults.length === 0 && isMyTeam }, { children: "\uD569\uACA9 \uC5EC\uBD80 \uBCC0\uACBD" }), void 0),
                        (0, jsx_runtime_1.jsx)(components_1.Button, __assign({ "$size": Button_component_1.ButtonSize.xs, shape: Button_component_1.ButtonShape.defaultLine, onClick: function () {
                                var workBook = getWorkBook();
                                if (!workBook) {
                                    return;
                                }
                                (0, xlsx_1.writeFileXLSX)(workBook, "".concat((0, utils_1.formatDate)((0, dayjs_1.default)().format(), 'YYYY년 M월 D일(ddd)'), "-").concat(teamName || '전체', ".xlsx"));
                            }, disabled: selectedRows.length === 0 }, { children: "Export to Excel" }), void 0),
                    ],
                }, selectableRow: {
                    selectedCount: selectedRows.length,
                    selectedRows: selectedRows,
                    setSelectedRows: setSelectedRows,
                    handleSelectAll: handleSelectAll,
                }, sortOptions: {
                    sortTypes: sortTypes,
                    disableMultiSort: true,
                    handleSortColumn: function (_sortTypes) {
                        setSortTypes(_sortTypes);
                    },
                }, pagination: (0, jsx_runtime_1.jsx)(components_1.Pagination, { pageOptions: pageOptions, selectableSize: {
                        selectBoxPosition: loadedTableRows.length > 3 ? 'top' : 'bottom',
                        handleChangeSize: handleChangeSize,
                    }, handleChangePage: handleChangePage }, void 0), applicationParams: applicationParams }, void 0), (0, jsx_runtime_1.jsx)(components_1.BottomCTA, __assign({ boundaries: {
                    visibility: { topHeight: 179, bottomHeight: 20 },
                    noAnimation: { bottomHeight: 20 },
                } }, { children: (0, jsx_runtime_1.jsx)(components_1.Pagination, { pageOptions: pageOptions, selectableSize: {
                        selectBoxPosition: loadedTableRows.length > 3 ? 'top' : 'bottom',
                        handleChangeSize: handleChangeSize,
                    }, handleChangePage: handleChangePage }, void 0) }), void 0)] }, void 0));
};
exports.default = ApplicationList;
